import * as types from './types'

export const fetchCurrentRequest = () => ({
  type: types.FETCH_CURRENT_REQUEST,
})
export const fetchCurrentSuccess = (partner) => ({
  type: types.FETCH_CURRENT_SUCCESS,
  payload: {
    partner,
  },
})
export const fetchCurrentFailure = (error) => ({
  type: types.FETCH_CURRENT_FAILURE,
  payload: {
    error,
  },
})
export const setUserSettings = (settings) => ({
  type: types.SET_USER_SETTINGS,
  payload: {
    settings,
  },
})

export const createPartnerRequest = () => ({
  type: types.CREATE_PARTNER_REQUEST,
})
export const createPartnerSuccess = (msg) => ({
  type: types.CREATE_PARTNER_SUCCESS,
  payload: { msg },
})
export const createPartnerFailure = (error) => ({
  type: types.CREATE_PARTNER_FAILURE,
  payload: {
    error,
  },
})

export const verifyPhoneNumberRequest = () => ({
  type: types.VERIFY_PHONE_NUMBER_REQUEST,
})
export const verifyPhoneNumberSuccess = (payload) => ({
  type: types.VERIFY_PHONE_NUMBER_SUCCESS,
  payload,
})
export const verifyPhoneNumberFailure = (error) => ({
  type: types.VERIFY_PHONE_NUMBER_FAILURE,
  payload: {
    error,
  },
})

export const confirmPhoneNumberRequest = () => ({
  type: types.CONFIRM_PHONE_NUMBER_REQUEST,
})
export const confirmPhoneNumberSuccess = () => ({
  type: types.CONFIRM_PHONE_NUMBER_SUCCESS,
})
export const confirmPhoneNumberFailure = (error) => ({
  type: types.CONFIRM_PHONE_NUMBER_FAILURE,
  payload: {
    error,
  },
})
